import React, { Component, Fragment } from "react";
import { Card, CardBody, CardFooter, Button } from "reactstrap"
import Slider from "rc-slider"
import { Check } from "react-feather";
import Radio from "../../../theme/@vuexy/radio/RadioVuexy";
import Checkbox from "../../../theme/@vuexy/checkbox/CheckboxesVuexy";
import "rc-slider/assets/index.css"
import { inject, observer } from 'mobx-react';
import "../../../assets/scss/plugins/extensions/slider.scss"
import { newDocFilterInstance } from "../../../types/IDocument";

const createSliderWithTooltip = Slider.createSliderWithTooltip
const Range = createSliderWithTooltip(Slider.Range)


@inject('libraryStore')
@observer
class FiltersSection extends Component {

  componentDidMount = () => {
    const { libraryStore } = this.props;
    libraryStore.loadSideBarFilterData();
  }

  handleCategory = (e, value) => {
    const { libraryStore } = this.props;
    libraryStore.setDocumentFilter({ category: value });
    libraryStore.loadDocuments();
  }

  handleContentTypes = (e, value) => {
    const { libraryStore } = this.props;
    //Todo: consolidate
    libraryStore.setDocumentFilter({ contentTypes: [value] }, e.target.checked);
    libraryStore.loadDocuments();
  }

  handleSlider = value => {
    const { libraryStore } = this.props;
    libraryStore.setDocumentFilter({ customerStage: e.target.value });
    libraryStore.loadDocuments();
  }

  handleSharable = e => {
    const { libraryStore } = this.props;
    libraryStore.setDocumentFilter({ isSharable: e.target.value });
    libraryStore.loadDocuments();
  }

  clearFilters = () => {
    const { libraryStore } = this.props;
    libraryStore.setDocumentFilter(newDocFilterInstance());
    libraryStore.loadDocuments();
  }

  render() {
    const { docCategoryList, contentTypeList, documentFilter } = this.props.libraryStore;

    const categoriesUL = <ul className="list-unstyled price-range">
      <li>
        <Radio
          label="All"
          name="category"
          className="py-25"
          checked={documentFilter.category === 'ALL'}
          onChange={(e) => {this.handleCategory(e, 'ALL')}}
        />
      </li>
      {
        docCategoryList.map((lookupItem, index) => {
          return (
            <li key={index}>
              <Radio
                label={lookupItem.name}
                name="category"
                className="py-25"
                checked={documentFilter.category === lookupItem.categoryCode}
                onChange={(e) => {this.handleCategory(e, `${lookupItem.categoryCode}`)}}
              />
            </li>
          );
        })
      }
    </ul>;

    const contentTypeUL = <ul className="list-unstyled brand-list">
      <li className="py-25">
        <Checkbox
          color="primary"
          name="type"
          icon={<Check className="vx-icon" size={16} />}
          label='All'
          checked={documentFilter.contentTypes.includes('ALL')}
          onChange={(e) => { this.handleContentTypes(e, 'ALL') }}
        />
      </li>
      {
        contentTypeList.map((lookupItem, index) => {
          return (
            <li className="py-25" key={index}>
              <Checkbox
                color="primary"
                name="type"
                icon={<Check className="vx-icon" size={16} />}
                label={lookupItem.name}
                checked={documentFilter.contentTypes.includes(lookupItem.value)}
                onChange={(e) => { this.handleContentTypes(e, `${lookupItem.value}`) }}
              />
            </li>
          )
        })
      }
    </ul>;


    const customerStageSlider = <div className="price-slider mt-1">
      <Range
        min={1}
        max={5}
        defaultValue={[1, (value) => { return value }]}
        onChange={(value) => { this.handleSlider(value) }}
        tipFormatter={value => `${value}`}
      />
    </div>;

    const sharableCheckBox = <span className="mt-2">
      <Checkbox
        color="primary"
        checked={documentFilter.isSharable}
        onChange={() => { this.handleSharable}}
        icon={<Check className="vx-icon" size={16} />}
        label="Sharable"
        defaultChecked={false}
      />
    </span>;

    const clearAllBtn =  <div className="actions-left d-flex flex-wrap view-btn-option">
    <Button
      color="primary"
      className="btn btn-block "
      size="md"
      onClick={() => this.clearFilters(true, true)}>
      <span className="align-middle">Clear Filters</span>
    </Button>
  </div>

    return (
      <Fragment>
        <h6 className="filter-heading d-none d-lg-block">Filters</h6>
        <Card className="mt-2">
          <CardBody className="p-2">
            <div className="multi-range-price">
              <div className="multi-range-title pb-75">
                <h6 className="filter-title mb-0">Category</h6>
              </div>
              {categoriesUL}
            </div>
            <hr />
            <div className="price-slider">
              <div className="price-slider-title mt-1">
                <h6 className="filter-title mb-0">Stage</h6>
              </div>
              {customerStageSlider}
            </div>
            <hr />
            <div className="brands">
              <div className="brand-title mt-1 pb-1">
                <h6 className="filter-title mb-0">Type</h6>
              </div>
              <div className="brand-list">
                {contentTypeUL}
              </div>
            </div>
            <hr />
            <div>
              {sharableCheckBox}
            </div>
            <br />
            { clearAllBtn }
          </CardBody>
        </Card>
      </Fragment>
    );
  }
}

export default FiltersSection;